import { render, staticRenderFns } from "./categoryEditForm.vue?vue&type=template&id=f5bdab54&"
import script from "./categoryEditForm.vue?vue&type=script&lang=js&"
export * from "./categoryEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports